if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.productWrapper = this.closest('.thb-product-detail');
      this.other = this.productWrapper ? Array.from(this.productWrapper.querySelectorAll('variant-selects')).filter((selector) => {
        return selector !== this;
      }) : [];
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.variantRequestId = 0;
      this.variantRequestController = null;

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.prefetchProductUrls();
    }

    onVariantChange(e) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updateProductPageLinks(null, true);
      this.removeErrorMessage();
      this.updateVariantText();

      this.updateMediaFromInput(e);
      this.renderVariantInfo();

      this.updateOther();
    }

    updateMediaFromInput(e) {
      if (!e || !e.target) return;
      const input = e.target.closest('input, select, option') || e.target;
      let mediaId;
      if (input.tagName === 'SELECT') {
        const selected = input.selectedOptions[0];
        mediaId = selected && selected.dataset.featuredMediaId;
      } else {
        mediaId = input.dataset.featuredMediaId;
      }
      if (!mediaId) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${mediaId}`,
        `#Thumb-${this.dataset.section}-${mediaId}`,
        this.productSlider,
        thumbnails
      );
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      this.updateProductPageLinks(this.currentVariant);
      const productForms = this.productWrapper.querySelectorAll(`[id="product-form-${this.dataset.section}"], [id="product-form-installment-${this.dataset.section}"], [id="product-form-installment"]`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.productWrapper.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      pickUpAvailability.update(this.currentVariant);
    }

    updateProductPageLinks(variant, pending = false) {
      this.productWrapper.querySelectorAll('[data-idg-variant-product-link]').forEach((link) => {
        if (pending) {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('aria-busy', 'true');
          link.setAttribute('tabindex', '0');
          return;
        }
        const url = new URL(link.dataset.idgVariantProductLink, window.location.origin);
        if (variant?.id) url.searchParams.set('variant', String(variant.id));
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
        link.removeAttribute('aria-disabled');
        link.removeAttribute('aria-busy');
        link.removeAttribute('tabindex');
      });
    }

    removeErrorMessage() {
      const productForm = this.productWrapper && this.productWrapper.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    handleVariantRequestError(error) {
      console.error(error);
      this.updateProductPageLinks(null);
      this.toggleAddButton(true, 'REFRESH TO RETRY');
      const productForm = this.productWrapper && this.productWrapper.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage('We could not update this option. Refresh the page and try again.');
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    formatCampaignMoney(cents) {
      const format = this.productWrapper?.dataset.campaignMoneyFormat
        || window.theme?.settings?.money_with_currency_format
        || '${{amount}}';
      const holder = document.createElement('span');
      holder.innerHTML = formatMoney(cents, format);
      return holder.textContent;
    }

    applyCampaignPrice(destination) {
      if (!destination || !this.productWrapper || this.productWrapper.dataset.campaignEnabled !== 'true') return;

      const sourcePrice = destination.querySelector('.price[data-product-price-cents]');
      if (!sourcePrice) return;

      const basePrice = parseInt(sourcePrice.dataset.productPriceCents, 10);
      const compareAtPrice = parseInt(sourcePrice.dataset.compareAtPriceCents, 10) || 0;
      const discountBps = parseInt(this.productWrapper.dataset.campaignDiscountBps, 10);
      if (!Number.isFinite(basePrice) || !Number.isFinite(discountBps) || discountBps <= 0) return;

      const campaignPrice = Math.max(0, basePrice - Math.floor((basePrice * discountBps) / 10000));
      const priceLabel = this.productWrapper.dataset.campaignPriceLabel || 'SEPTEMBER EVENT PRICE';
      const msrpLabel = this.productWrapper.dataset.campaignMsrpLabel || 'MSRP';
      const codeLabel = this.productWrapper.dataset.campaignCodeLabel || 'AUTO-APPLIED AT CART';
      const offLabel = this.productWrapper.dataset.campaignOffLabel || 'OFF MSRP';
      const campaignCode = this.productWrapper.dataset.campaignCode || '';

      const shell = document.createElement('div');
      shell.className = 'idg-campaign-price-shell';
      shell.dataset.campaignPriceShell = '';

      const eyebrow = document.createElement('span');
      eyebrow.className = 'idg-campaign-price__eyebrow';
      eyebrow.textContent = priceLabel;
      shell.appendChild(eyebrow);

      const price = document.createElement('span');
      price.className = 'price idg-campaign-price';
      price.dataset.productPriceCents = String(basePrice);
      price.dataset.compareAtPriceCents = String(compareAtPrice);
      price.dataset.campaignPriceCents = String(campaignPrice);

      if (compareAtPrice > campaignPrice) {
        const original = document.createElement('del');
        original.className = 'idg-campaign-price__msrp';
        const hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = `${msrpLabel}: `;
        const amount = document.createElement('span');
        amount.className = 'amount';
        amount.textContent = this.formatCampaignMoney(compareAtPrice);
        original.append(hidden, amount);
        price.appendChild(original);
      }

      const current = document.createElement('ins');
      current.className = 'idg-campaign-price__current';
      const currentHidden = document.createElement('span');
      currentHidden.className = 'visually-hidden';
      currentHidden.textContent = `${priceLabel}: `;
      const currentAmount = document.createElement('span');
      currentAmount.className = 'amount discounted';
      currentAmount.textContent = this.formatCampaignMoney(campaignPrice);
      current.append(currentHidden, currentAmount);
      price.appendChild(current);

      if (compareAtPrice > campaignPrice) {
        const totalOff = Math.round(((compareAtPrice - campaignPrice) * 100) / compareAtPrice);
        const badges = document.createElement('span');
        badges.className = 'badges idg-campaign-price__badges';
        const badge = document.createElement('span');
        badge.className = 'badge idg-campaign-price__badge';
        badge.textContent = `${totalOff}% ${offLabel}`;
        badges.appendChild(badge);
        price.appendChild(badges);
      }

      const code = document.createElement('p');
      code.className = 'idg-campaign-price__code';
      const codePrefix = document.createElement('span');
      codePrefix.textContent = 'CODE';
      const strong = document.createElement('strong');
      strong.className = 'idg-campaign-price__code-value';
      strong.textContent = campaignCode;
      code.append(codePrefix, document.createTextNode(' '), strong, document.createTextNode(` · ${codeLabel}`));

      shell.append(price, code);
      destination.replaceChildren(shell);
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    prefetchProductUrls() {
      this._prefetchCache = this._prefetchCache || new Map();
      this.querySelectorAll('[data-product-url]').forEach((el) => {
        let url = el.dataset.productUrl;
        if (url === this.dataset.url) return;
        let label = el.tagName === 'OPTION' ? el.closest('select') : el.nextElementSibling;
        if (!label) return;
        label.addEventListener('mouseenter', () => {
          if (this._prefetchCache.has(url)) return;
          let fetchUrl = `${url}?section_id=${this.dataset.section}`;
          this._prefetchCache.set(url, fetch(fetchUrl).then((r) => r.text()));
        }, { once: true });
      });
    }

    getProductUrl() {
      for (let fieldset of this.fieldsets) {
        let select = fieldset.querySelector('select');
        let selected = select ? select.selectedOptions[0] : fieldset.querySelector('input:checked');
        if (selected && selected.dataset.productUrl && selected.dataset.productUrl !== this.dataset.url) {
          return selected.dataset.productUrl;
        }
      }
      return null;
    }

    switchProduct(productUrl) {
      this.toggleAddButton(true, '', false);
      const sectionId = this.dataset.section;
      const cached = this._prefetchCache && this._prefetchCache.get(productUrl);
      const request = cached || fetch(`${productUrl}?section_id=${sectionId}`).then((response) => {
        if (!response.ok) throw new Error(`Product section request failed (${response.status})`);
        return response.text();
      });

      request.then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContent = doc.getElementById(`shopify-section-${sectionId}`);
        const currentSection = document.getElementById(`shopify-section-${sectionId}`);

        if (newContent && currentSection) {
          currentSection.innerHTML = newContent.innerHTML;
        }

        if (this.updateUrl) history.replaceState({}, '', productUrl);
      }).catch((error) => {
        this.handleVariantRequestError(error);
      });
    }

    renderVariantInfo() {
      const productUrl = this.getProductUrl();
      if (productUrl) {
        this.switchProduct(productUrl);
        return;
      }

      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;

      if (this.variantRequestController) this.variantRequestController.abort();
      this.variantRequestController = new AbortController();
      const requestId = ++this.variantRequestId;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`, {
        signal: this.variantRequestController.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Variant request failed (${response.status})`);
          return response.text();
        })
        .then((responseText) => {
          if (requestId !== this.variantRequestId) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 0. Combined listings: check if response is a different product
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
            this.switchProduct(span.dataset.productUrl);
            return;
          }

          // 1. Resolve variant from hidden span
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = this.productWrapper.querySelector(`[id="${id}"]`);
            const source = html.getElementById(id);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              if (id === `price-${this.dataset.section}` || id === `price-${this.dataset.section}--sticky`) {
                this.applyCampaignPrice(destination);
              }
            }
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            this.updatePickupAvailability();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            dispatchCustomEvent('product:variant-change', {
              variant: null,
              sectionId: this.dataset.section,
              variantTitle: this.options.join(' / ')
            });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          this.updatePickupAvailability();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
          dispatchCustomEvent('product:variant-change', {
            variant: this.currentVariant,
            sectionId: this.dataset.section,
            variantTitle: this.options.join(' / ')
          });
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          this.handleVariantRequestError(error);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = this.productWrapper.querySelector(`[id="product-form-${this.dataset.section}"]`);
      if (!productForm || productForm.hasAttribute('data-idg-variant-owner')) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = this.productWrapper.querySelectorAll('.single-add-to-cart-button, [data-campaign-checkout]');
      const campaignUnavailable = this.productWrapper.dataset.campaignUnavailable === 'true';

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable || campaignUnavailable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (campaignUnavailable) submitButton.setAttribute('aria-disabled', 'true');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (submitButton.dataset.availableText) {
            submitButtonText.textContent = submitButton.dataset.availableText;
          } else if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      this.updateProductPageLinks(null);
      const submitButtons = this.productWrapper.querySelectorAll('.single-add-to-cart-button, [data-campaign-checkout]');
      const price = this.productWrapper.querySelector(`[id="price-${this.dataset.section}"]`);
      const price_fixed = this.productWrapper.querySelector(`[id="price-${this.dataset.section}--sticky"]`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButton.setAttribute('disabled', 'disabled');
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      const fieldset = this.fieldsets[optionPosition];
      if (!fieldset) return;
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');
      let setValue;
      if (select && select.selectedOptions[0]) {
        setValue = select.selectedOptions[0].dataset.handle;
      } else if (checked) {
        setValue = checked.dataset.handle;
      }
      if (!setValue) return;
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      if (this.dataset.featuredCustomImage === 'true') {
        this.featuredMediaOrder = this.featuredMediaOrder || Array.from(this.querySelectorAll('.product-images__slide'));
        this.featuredMediaOrder.forEach(slide => this.appendChild(slide));
      }
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      // Flickity appends active cells after hidden media on destroy. Keep the
      // custom-image gallery aligned with its original thumbnail order.
      if (this.featuredMediaOrder) {
        this.featuredMediaOrder.forEach(slide => this.appendChild(slide));
      }

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
      document.addEventListener('product:variant-change', (e) => {
        if (e.detail && e.detail.sectionId === this.dataset.section && e.detail.variantTitle && e.detail.variantTitle !== 'Default Title') {
          this.dataset.variantTitle = e.detail.variantTitle;
        }
      });
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          thumbSrc: activelink.dataset.thumbSrc || activelink.dataset.msrc
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: true,
        allowPanToNext: true,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    disconnectedCallback() {
      if (this.flkty) {
        this.flkty.destroy();
      }
    }
    buildPswpThumbnails(items) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      container.innerHTML = '';
      if (this.dataset.lightboxThumbnails === 'false' || items.length <= 1) {
        container.parentElement.style.display = 'none';
        return;
      }
      container.parentElement.style.display = '';
      items.forEach((item, index) => {
        const thumb = document.createElement('div');
        thumb.className = 'pswp__thumb';
        thumb.dataset.index = index;
        const img = document.createElement('img');
        img.src = item.thumbSrc;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        container.appendChild(thumb);
      });
    }
    updatePswpProductInfo() {
      const infoEl = this.pswpElement.querySelector('.pswp__product-info');
      if (!infoEl) return;
      if (this.dataset.lightboxProductInfo === 'false') {
        infoEl.style.display = 'none';
        return;
      }
      infoEl.style.display = '';
      const titleEl = infoEl.querySelector('.pswp__product-title');
      const variantEl = infoEl.querySelector('.pswp__variant-title');
      if (titleEl) titleEl.textContent = this.dataset.productTitle || '';
      if (variantEl) variantEl.textContent = this.dataset.variantTitle || '';
    }
    syncPswpThumbnails(index) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      const thumbs = container.querySelectorAll('.pswp__thumb');
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
      });
      const activeThumb = container.querySelector('.pswp__thumb.is-active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        this.buildPswpThumbnails(this.items);
        this.updatePswpProductInfo();

        // Prevent touch/mouse events on bottom bar from reaching PhotoSwipe's gesture handler
        const bottomBar = this.pswpElement.querySelector('.pswp__bottom-bar');
        if (bottomBar) {
          ['mousedown', 'touchstart', 'pointerdown'].forEach(evtName => {
            bottomBar.addEventListener(evtName, (evt) => evt.stopPropagation());
          });
        }

        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        const _this = this;
        document.body.classList.add('open-lightbox');

        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 140
            };
          });
        });

        // Reset any accidental parent scroll caused by loop transition
        const scrollWrap = this.pswpElement.querySelector('.pswp__scroll-wrap');
        const resetScroll = function() {
          if (scrollWrap) scrollWrap.scrollLeft = 0;
          _this.pswpElement.scrollLeft = 0;
        };

        pswp.listen('beforeChange', function () {
          const index = pswp.getCurrentIndex();
          _this.syncPswpThumbnails(index);
          resetScroll();
          // Sync product slideshow with lightbox
          if (_this.flkty) {
            _this.flkty.select(index);
          }
        });

        const thumbsInner = this.pswpElement.querySelector('.pswp__thumbs-inner');
        if (thumbsInner) {
          thumbsInner.addEventListener('click', function handler(evt) {
            evt.stopPropagation();
            const thumb = evt.target.closest('.pswp__thumb');
            if (thumb) {
              pswp.goTo(parseInt(thumb.dataset.index, 10));
              resetScroll();
            }
          });
        }

        pswp.listen('close', function () {
          const container = _this.pswpElement.querySelector('.pswp__thumbs-inner');
          if (container) container.innerHTML = '';
        });

        pswp.init();
        this.syncPswpThumbnails(this.pswpOptions.index);
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this._submitting = false;
      this.checkoutRequested = false;
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.productWrapper = this.closest('.thb-product-detail');
      this.form = this.productWrapper?.querySelector(`[id="product-form-${this.dataset.section}"]`);
      if (!this.form) return;
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.checkoutButton = this.querySelector('[data-campaign-checkout]');
      if (this.checkoutButton) {
        this.checkoutButton.addEventListener('click', () => {
          if (this.checkoutButton.disabled || this._submitting) return;
          this.checkoutRequested = true;
          this.form.requestSubmit();
        });
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this._submitting || !this.form.reportValidity()) return;
      this._submitting = true;

      // Snapshot the selected variant, displayed campaign price and checkout
      // intent before this request enters the shared cart queue. A shopper may
      // continue changing options while another product is finishing its cart
      // mutation; the queued operation must still purchase exactly what they
      // clicked and verify against exactly what they saw.
      const campaignEnabled = this.dataset.campaignEnabled === 'true';
      const expectedPriceElement = campaignEnabled
        ? this.productWrapper?.querySelector('[data-campaign-price-cents]')
        : null;
      const submission = {
        formData: new FormData(this.form),
        checkoutRequested: this.checkoutRequested,
        campaignCode: (this.dataset.campaignCode || '').trim(),
        discountBps: parseInt(this.dataset.campaignDiscountBps, 10),
        expectedBasePrice: parseInt(expectedPriceElement?.dataset.productPriceCents, 10),
        expectedPrice: parseInt(expectedPriceElement?.dataset.campaignPriceCents, 10)
      };
      this.lockVariantControls();

      const submitButtons = this.getSubmitButtons();

      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();
      let keepCampaignButtonsDisabled = false;
      const request = this.enqueueCartMutation(() => this.submitProduct(campaignEnabled, submission));

      request
        .catch((error) => {
          console.error(error);
          keepCampaignButtonsDisabled = error.keepCampaignButtonsDisabled === true;
          if (keepCampaignButtonsDisabled && this.productWrapper) {
            this.productWrapper.dataset.campaignUnavailable = 'true';
          }
          let message = campaignEnabled
            ? (this.dataset.campaignError || 'We could not verify the event price. Please review your cart or enter the code manually.')
            : 'Something went wrong. Please try again.';
          if (error.isCartAddError) {
            message = error.message;
          } else if (error.isCampaignRollbackError) {
            message = 'We could not safely restore your cart. Do not continue to checkout. Refresh the page and review your cart, or contact support.';
          } else if (error.campaignCartRestored) {
            message = 'The event price could not be verified, so this item was not added. Refresh the page and try again later.';
          }
          this.handleErrorMessage(message);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            if (keepCampaignButtonsDisabled) {
              submitButton.setAttribute('aria-disabled', 'true');
              submitButton.setAttribute('disabled', 'disabled');
            } else {
              submitButton.removeAttribute('aria-disabled');
              if (!submitButton.classList.contains('sold-out')) submitButton.removeAttribute('disabled');
            }
          });
          this.unlockVariantControls();
          this._submitting = false;
          this.checkoutRequested = false;
        });
    }

    lockVariantControls() {
      this.lockedVariantControls = Array.from(
        this.productWrapper?.querySelectorAll('variant-selects input, variant-selects select') || []
      ).map((control) => ({ control, wasDisabled: control.disabled }));
      this.lockedVariantControls.forEach(({ control }) => {
        control.disabled = true;
      });
    }

    unlockVariantControls() {
      (this.lockedVariantControls || []).forEach(({ control, wasDisabled }) => {
        control.disabled = wasDisabled;
      });
      this.lockedVariantControls = [];
    }

    getSubmitButtons() {
      return this.productWrapper
        ? this.productWrapper.querySelectorAll('.single-add-to-cart-button, [data-campaign-checkout]')
        : this.querySelectorAll('.single-add-to-cart-button, [data-campaign-checkout]');
    }

    enqueueCartMutation(operation) {
      const previous = window.__idgCartMutationQueue || Promise.resolve();
      const current = previous.catch(() => undefined).then(operation);
      window.__idgCartMutationQueue = current.catch(() => undefined);
      return current;
    }

    async submitProduct(campaignEnabled, submission) {
      const beforeCart = campaignEnabled ? await this.fetchCart() : null;
      const formData = submission.formData;
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      let addedItem = null;
      let cartState = null;
      try {
        // In campaign mode the add request itself is part of the transaction.
        // A response can be lost after Shopify has accepted the write, so any
        // ambiguous add result must be reconciled against the before-cart.
        const addResponse = await fetch(`${theme.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        });
        const addState = await this.readJsonResponse(addResponse, 'Unable to add this item to the cart.');

        if (!addResponse.ok || addState.status) {
          dispatchCustomEvent('product:variant-error', {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: addState.description,
            message: addState.message
          });
          if (addState.status === 422) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
          const addError = new Error(addState.description || addState.message || 'Unable to add this item to the cart.');
          addError.isCartAddError = true;
          throw addError;
        }

        addedItem = Object.prototype.hasOwnProperty.call(addState, 'items') ? addState.items[0] : addState;

        if (!campaignEnabled) {
          this.renderContents(addState);
          dispatchCustomEvent('cart:item-added', { product: addedItem });
          return;
        }

        cartState = await this.applyCampaignDiscount(beforeCart, addedItem, formData, submission);
      } catch (error) {
        if (!campaignEnabled) throw error;
        try {
          const restoredState = await this.rollbackCampaignAdd(beforeCart, addedItem, formData);
          if (restoredState?.sections) this.renderContents(restoredState, false);
        } catch (rollbackError) {
          console.error('Campaign cart rollback failed', rollbackError);
          const unsafeCartError = new Error('Campaign cart rollback failed.');
          unsafeCartError.isCampaignRollbackError = true;
          unsafeCartError.keepCampaignButtonsDisabled = true;
          throw unsafeCartError;
        }
        error.campaignCartRestored = true;
        error.keepCampaignButtonsDisabled = true;
        throw error;
      }

      this.renderContents(cartState, !submission.checkoutRequested);
      dispatchCustomEvent('cart:item-added', { product: addedItem });

      if (submission.checkoutRequested) {
        const root = window.Shopify?.routes?.root || theme.routes.root_url || '/';
        window.location.assign(`${root.replace(/\/?$/, '/')}checkout`);
      }
    }

    async fetchCart() {
      const response = await fetch(`${theme.routes.cart_url}.js`, {
        headers: { 'Accept': 'application/json' }
      });
      const state = await this.readJsonResponse(response, 'Unable to read the cart.');
      if (!response.ok) throw new Error('Unable to read the cart.');
      return state;
    }

    async readJsonResponse(response, fallbackMessage) {
      let state;
      try {
        state = await response.json();
      } catch (error) {
        throw new Error(fallbackMessage);
      }
      if (!response.ok && !state?.status) throw new Error(fallbackMessage);
      return state;
    }

    collectDiscountCodes(cart) {
      const codes = new Map();
      const addCode = (code, applicable = true) => {
        if (typeof code !== 'string' || !code.trim()) return;
        const normalized = code.trim().toLowerCase();
        if (!codes.has(normalized) || applicable === true) {
          codes.set(normalized, { code: code.trim(), applicable });
        }
      };

      if (Array.isArray(cart?.discount_codes)) {
        cart.discount_codes.forEach((discount) => addCode(discount.code, discount.applicable !== false));
      }
      if (Array.isArray(cart?.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((application) => {
          if (application.type === 'discount_code') addCode(application.title, true);
        });
      }
      if (Array.isArray(cart?.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;
          item.line_level_discount_allocations.forEach((allocation) => {
            const application = allocation.discount_application;
            if (application?.type === 'discount_code') addCode(application.title, true);
          });
        });
      }
      return Array.from(codes.values());
    }

    normalizeLineProperties(properties) {
      if (!properties || typeof properties !== 'object') return '';
      const entries = Object.keys(properties).sort().map((key) => [key, String(properties[key])]);
      return entries.length ? JSON.stringify(entries) : '';
    }

    getSellingPlanId(item) {
      return item?.selling_plan_allocation?.selling_plan?.id
        || item?.selling_plan_allocation?.selling_plan_id
        || item?.selling_plan
        || null;
    }

    buildCartLineReference(formData) {
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value) !== '') properties[match[1]] = String(value);
      }
      return {
        variant_id: parseInt(formData.get('id'), 10),
        properties,
        selling_plan: formData.get('selling_plan') || null
      };
    }

    hasSameLineIdentity(item, reference, variantId) {
      if (!item || !reference) return false;
      const referenceVariantId = reference.variant_id || reference.id || variantId;
      return Number(item.variant_id || item.id) === Number(referenceVariantId)
        && String(this.getSellingPlanId(item) || '') === String(this.getSellingPlanId(reference) || '')
        && this.normalizeLineProperties(item.properties) === this.normalizeLineProperties(reference.properties);
    }

    findCartItem(cart, reference, variantId) {
      if (!Array.isArray(cart?.items) || !reference) return null;
      const byKey = cart.items.find((item) => reference.key && item.key === reference.key);
      if (byKey) return byKey;
      const matches = cart.items.filter((item) => this.hasSameLineIdentity(item, reference, variantId));
      return matches.length === 1 ? matches[0] : null;
    }

    assertPreviousCartLinesPreserved(beforeCart, state, addedItem = null, addedQuantity = 0) {
      if (!Array.isArray(beforeCart?.items) || !Array.isArray(state?.items)
        || (beforeCart.currency && state.currency !== beforeCart.currency)) {
        throw new Error('The existing cart could not be verified.');
      }
      const matched = new Set();
      for (const previousItem of beforeCart.items) {
        const currentItem = this.findCartItem(state, previousItem);
        const previousQuantity = Number(previousItem.quantity);
        const currentQuantity = Number(currentItem?.quantity);
        const previousTotal = Number(previousItem.final_line_price);
        const currentTotal = Number(currentItem?.final_line_price);
        const increment = addedItem && this.hasSameLineIdentity(previousItem, addedItem)
          ? addedQuantity : 0;
        // A merged quantity can redistribute a sub-cent allocation. Cap at the
        // old rounded-up unit price; unchanged lines get no price tolerance.
        const maximumTotal = increment > 0
          ? Math.ceil(previousTotal / previousQuantity) * currentQuantity : previousTotal;
        if (!currentItem || matched.has(currentItem)
          || !Number.isSafeInteger(previousQuantity) || previousQuantity <= 0
          || !Number.isSafeInteger(currentQuantity) || currentQuantity !== previousQuantity + increment
          || !Number.isSafeInteger(previousTotal) || previousTotal < 0
          || !Number.isSafeInteger(currentTotal) || currentTotal < 0
          || currentTotal > maximumTotal) {
          throw new Error('An existing cart item changed or became more expensive.');
        }
        matched.add(currentItem);
      }
      // A shared P-series code may legitimately make an existing P line cheaper.
      // Do not require exact equality, but never silently sacrifice an old offer.
    }

    async applyCampaignDiscount(beforeCart, addedItem, formData, submission) {
      const campaignCode = submission.campaignCode;
      const discountBps = submission.discountBps;
      const expectedBasePrice = submission.expectedBasePrice;
      const expectedPrice = submission.expectedPrice;
      if (!campaignCode || !Number.isFinite(discountBps) || discountBps <= 0 || !Number.isFinite(expectedBasePrice) || !Number.isFinite(expectedPrice)) {
        throw new Error('Campaign configuration is incomplete.');
      }

      const previousCodes = this.collectDiscountCodes(beforeCart).filter((discount) => discount.applicable !== false);
      const codesToApply = previousCodes.map((discount) => discount.code);
      if (!codesToApply.some((code) => code.toLowerCase() === campaignCode.toLowerCase())) {
        codesToApply.push(campaignCode);
      }

      const response = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          discount: codesToApply.join(','),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })
      });
      const state = await this.readJsonResponse(response, 'Unable to apply the campaign code.');
      if (!response.ok) throw new Error('Unable to apply the campaign code.');

      const resultingCodes = this.collectDiscountCodes(state);
      const hasApplicableCode = (code) => resultingCodes.some((discount) => {
        return discount.code.toLowerCase() === code.toLowerCase() && discount.applicable === true;
      });
      if (!hasApplicableCode(campaignCode)) throw new Error('The campaign code is not applicable.');
      if (previousCodes.some((discount) => !hasApplicableCode(discount.code))) {
        throw new Error('The campaign code cannot be combined with an existing discount.');
      }

      const variantId = parseInt(formData.get('id'), 10);
      const cartItem = this.findCartItem(state, addedItem, variantId);
      if (!cartItem) throw new Error('The added campaign item could not be verified.');

      const quantity = Number(cartItem.quantity);
      const requestedQuantity = Number(formData.get('quantity') || 1);
      const previousItem = this.findCartItem(beforeCart, addedItem, variantId);
      const expectedQuantity = Number(previousItem?.quantity || 0) + requestedQuantity;
      const finalLinePrice = Number(cartItem.final_line_price);
      const originalUnitPrice = Number(cartItem.original_price);
      const campaignAllocation = Array.isArray(cartItem.line_level_discount_allocations)
        ? cartItem.line_level_discount_allocations
          .filter((allocation) => {
            const application = allocation.discount_application;
            return application?.type === 'discount_code'
              && application.title?.toLowerCase() === campaignCode.toLowerCase();
          })
          .reduce((total, allocation) => total + Number(allocation.amount || 0), 0)
        : 0;
      const minimumCampaignDiscount = (expectedBasePrice - expectedPrice) * quantity;
      const maximumCampaignDiscount = Math.floor((expectedBasePrice * quantity * discountBps) / 10000);
      const maximumExpectedLinePrice = expectedPrice * quantity;
      if (!Number.isFinite(quantity) || !Number.isFinite(requestedQuantity) || requestedQuantity < 1
        || quantity !== expectedQuantity
        || originalUnitPrice !== expectedBasePrice
        || !Number.isFinite(finalLinePrice)
        || finalLinePrice > maximumExpectedLinePrice
        || campaignAllocation < minimumCampaignDiscount
        || campaignAllocation > maximumCampaignDiscount) {
        throw new Error('The cart price does not match the displayed campaign price.');
      }

      this.assertPreviousCartLinesPreserved(beforeCart, state, addedItem, requestedQuantity);

      return state;
    }

    async rollbackCampaignAdd(beforeCart, addedItem, formData) {
      const variantId = parseInt(formData.get('id'), 10);
      const lineReference = addedItem || this.buildCartLineReference(formData);
      if (!Number.isFinite(variantId)) throw new Error('The added cart line could not be identified.');
      const currentCart = await this.fetchCart();
      const currentItem = this.findCartItem(currentCart, lineReference, variantId);
      const previousItem = this.findCartItem(beforeCart, lineReference, variantId);
      const previousQuantity = previousItem?.quantity || 0;

      if (!currentItem && Number(currentCart?.item_count || 0) > Number(beforeCart?.item_count || 0)) {
        throw new Error('The added cart line could not be safely restored.');
      }

      if (currentItem) {
        const changeResponse = await fetch(`${theme.routes.cart_change_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: currentItem.key, quantity: previousQuantity })
        });
        await this.readJsonResponse(changeResponse, 'Unable to restore the cart quantity.');
        if (!changeResponse.ok) throw new Error('Unable to restore the cart quantity.');
      }

      const previousCodes = this.collectDiscountCodes(beforeCart)
        .filter((discount) => discount.applicable !== false)
        .map((discount) => discount.code);
      const restoreResponse = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          discount: previousCodes.join(','),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })
      });
      const restoredState = await this.readJsonResponse(restoreResponse, 'Unable to restore the cart discounts.');
      if (!restoreResponse.ok) throw new Error('Unable to restore the cart discounts.');

      const restoredItem = this.findCartItem(restoredState, lineReference, variantId);
      const restoredQuantity = Number(restoredItem?.quantity || 0);
      const restoredCodes = this.collectDiscountCodes(restoredState)
        .filter((discount) => discount.applicable !== false)
        .map((discount) => discount.code.toLowerCase())
        .sort();
      const expectedCodes = previousCodes.map((code) => code.toLowerCase()).sort();
      if (restoredQuantity !== Number(previousQuantity)
        || Number(restoredState?.item_count) !== Number(beforeCart?.item_count)
        || restoredCodes.join('|') !== expectedCodes.join('|')) {
        throw new Error('The cart could not be verified after restoration.');
      }
      this.assertPreviousCartLinesPreserved(beforeCart, restoredState);
      return restoredState;
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState, openDrawer = true) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const sectionHtml = parsedState.sections && parsedState.sections[section.section];
        if (!sectionHtml) return;
        elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      if (!openDrawer) return;

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer && OverlayManager.isOpen(search_drawer)) {
        OverlayManager.close(search_drawer);
      }
      if (product_drawer && product_drawer.contains(this)) {
        OverlayManager.close(product_drawer);
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : '';
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.tl) {
        this.tl.kill();
      }
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        this.tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        this.tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', () => {
          this.tl.reversed() ? this.tl.play() : this.tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this;
      this.observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        });
      let form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      this.observer.observe(form);
      this.observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.buttons.toggleActiveClass(i);
          OverlayManager.open(this.drawer);
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
